import { inject, Injectable } from '@angular/core';
import { map, Observable, of, ReplaySubject } from 'rxjs';
import { Company } from './company.model';
import { StorageKeysEnum } from '../enums/storage.keys.enum';
import { HttpService } from '../http/http.service';
import { Net2BeepleMethodsEnum } from '../enums/net2beeple-methods.enum';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    private _httpService: HttpService = inject(HttpService);

    public readonly structureCompanyId = '0000006T';
    
    private _company: ReplaySubject<Company> = new ReplaySubject<Company>(1);

    /**
     * Setter & getter for company
     *
     * @param value
     */
    set company(value: Company) {
        localStorage.setItem(StorageKeysEnum.company, JSON.stringify(value));
        // Store the value
        this._company.next(value);
    }

    get company$(): Observable<Company> {
        return this._company.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user company data
     */
    get(): Observable<Company> {
        const company = JSON.parse(localStorage.getItem(StorageKeysEnum.company)) as Company;
        this._company.next(company);
        return of(company);
    }

    /**
     * Update the company
     *
     * @param user
     */
    update(company: Company): Observable<Company> {
        return this._httpService.post<any>(Net2BeepleMethodsEnum.flushCompany, { company }).pipe(
            map((response) => {
                if (response && response.company) {
                    this._company.next(response.company);
                    localStorage.setItem(StorageKeysEnum.company, JSON.stringify(response.company));
                    return response.company;
                }
                return undefined;
            })
        );
    }

    delete() {
        localStorage.removeItem(StorageKeysEnum.company);
    }
}
